export default {
  label: {
    en: 'Notifications center',
  },
}
